<!-- day-view-wrapper.component.html -->
<div class="day-view-wrapper">
  <!-- Load mobile component for mobile devices -->
  <app-day-view-mobile *ngIf="isMobile"></app-day-view-mobile>
  
  <!-- Load desktop component for larger screens -->
  <app-day-view *ngIf="!isMobile"></app-day-view>
</div>